module.exports = __webpack_public_path__ + "img/mfd_in_2_pp3_name.05e330f9.png";